import React from 'react';
import { Navigate, useParams } from 'react-router';

// Keeps old /subscriptions/:subscriptionId bookmarks working; Navigate does not interpolate route params.
const SubscriptionInvoicesRedirect = () => {
  const { subscriptionId } = useParams();
  return <Navigate replace to={`/supplier-subscriptions/${encodeURIComponent(subscriptionId ?? '')}`} />;
};

export default SubscriptionInvoicesRedirect;
